const AlertTriangle = ({
  width = 32,
  height = 32,
  color = '#FF675D',
  ...other
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...other}
    color={color}
  >
    <path
      d="M16 17.1997V11.219M16 21.6327V21.6853M23.5599 26.6663H8.44009C6.3748 26.6663 4.6319 25.3014 4.08354 23.4339C3.84946 22.6368 4.13708 21.8065 4.57701 21.0995L12.1369 7.46771C13.9081 4.62144 18.0919 4.62144 19.8631 7.46771L27.423 21.0995C27.8629 21.8065 28.1505 22.6368 27.9165 23.4339C27.3681 25.3014 25.6252 26.6663 23.5599 26.6663Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AlertTriangle;
